import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useTaskModalStore = defineStore('taskModal', () => {
  const localTasks = ref([]);
  const tasks = ref([]);
  const inProgressTasks = ref([]);
  const completeTasks = ref([]);
  const errorTasks = ref([]);
  const terminatedTasks = ref([]);
  const showTasksModal = ref(false);
  const mode = ref('in_progress');

  const numLocalInProgressTasks = computed(() => localTasks.value.length || 0);

  const numInProgressTasks = computed(() => {
    if (inProgressTasks.value) {
      return inProgressTasks.value.length;
    } else {
      return 0;
    }
  });

  const numCompletedTasks = computed(() => {
    if (completeTasks.value) {
      return completeTasks.value.length;
    } else {
      return 0;
    }
  });

  const inProgressLocal = computed(() => numLocalInProgressTasks.value > 0);
  const inProgress = computed(() => numInProgressTasks.value > 0);

  const numErrorTasks = computed(() => {
    if (errorTasks.value) {
      return errorTasks.value.length;
    } else {
      return 0;
    }
  });

  const numTerminatedTasks = computed(() => {
    if (terminatedTasks.value) {
      return terminatedTasks.value.length;
    } else {
      return 0;
    }
  });

  function $reset() {
    localTasks.value = [];
    tasks.value = [];
    inProgressTasks.value = [];
    completeTasks.value = [];
    errorTasks.value = [];
    terminatedTasks.value = [];
    showTasksModal.value = false;
    mode.value = 'in_progress';
  }

  return {
    localTasks,
    numLocalInProgressTasks,
    inProgressLocal,
    tasks,
    inProgressTasks,
    completeTasks,
    errorTasks,
    terminatedTasks,
    numInProgressTasks,
    numCompletedTasks,
    inProgress,
    numErrorTasks,
    numTerminatedTasks,
    showTasksModal,
    mode,
    $reset,
  };
});
